(function () {
  "use strict";

  var analyticsLoaded = false;
  var askAiLoaded = false;
  var askAiObserver = null;
  var askAiObserverTimeout = null;
  var askAiHideWindowTimeout = null;
  var askAiCustomizeScheduled = false;
  var ASK_AI_BUTTON_ID = "askai-floating-button";
  var trackingConfig = window.T4STrackingConfig || {};
  function trackingId(value, fallback) {
    var id = value == null || String(value).trim() === "" ? fallback : String(value).trim();
    if (!id || id === "off") return "";
    return id;
  }
  var CLARITY_ID = trackingId(trackingConfig.clarityId, "ucik4je1bk");
  var TWITTER_PIXEL_ID = trackingId(trackingConfig.twitterId, "omc2s");
  var BING_UET_ID = trackingId(trackingConfig.bingId, "343061097");
  var ASK_AI_EMBED_ID = trackingId(trackingConfig.askAiId, "qmBhm21KeHcWNkJaUWHUHUOoTUXqYY");
  var ASK_AI_SCRIPT_ID = ASK_AI_EMBED_ID || "askai-embed";
  var ASK_AI_CUSTOMIZED_ATTR = "data-askai-customized";
  var ASK_AI_ACTIVE_CLASS = "askai-customization-active";
  var ASK_AI_CUSTOM_CONTENT_CLASS = "askai-custom-content";
  var ASK_AI_OBSERVER_TIMEOUT_MS = 30000;
  var ASK_AI_HIDE_WINDOW_MS = 8000;

  const closeIcon = `
  <svg t="1778209294793" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1760" width="20" height="20">
    <path d="M300.8 240.469333l211.2 211.2 211.2-211.2 60.330667 60.330667-211.2 211.2 211.2 211.2-60.373334 60.330667-211.2-211.2-211.157333 211.2-60.330667-60.330667 211.2-211.2-211.2-211.2L300.8 240.469333z" fill="#ffffff" p-id="1761"></path>
  </svg>`;

  function initCloseBtn() {
    const observer = new MutationObserver(() => {
      const doc = document.querySelector(`[data-id="${ASK_AI_SCRIPT_ID}"]`);

      if (!doc) return;

      console.log("doc found");

      // 停止监听 body
      observer.disconnect();

      // 避免重复创建
      if (doc.querySelector(".custom-close-btn")) return;

      // 创建关闭按钮
      const closeBtn = document.createElement("div");

      closeBtn.className = "custom-close-btn";
      closeBtn.innerHTML = closeIcon;

      // 按钮样式
      Object.assign(closeBtn.style, {
        position: "absolute",
        top: "20px",
        right: "13px",
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        background: "rgb(17, 17, 17)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: "999999",
        fontSize: "20px",
        lineHeight: "1",
        userSelect: "none",
      });

      // 控制按钮显示
      let hideBtnTimer = null;

      function updateBtnVisible() {
        const isVisible = doc.classList.contains("visible");

        // 清除上一次隐藏
        if (hideBtnTimer) {
          clearTimeout(hideBtnTimer);
          hideBtnTimer = null;
        }

        if (isVisible) {
          closeBtn.style.display = "flex";
        } else {
          hideBtnTimer = setTimeout(() => {
            // 再确认一次状态
            if (!doc.classList.contains("visible")) {
              closeBtn.style.display = "none";
            }
          }, 400);
        }
      }

      // 点击切换 visible / hidden
      closeBtn.addEventListener("click", () => {
        if (doc.classList.contains("visible")) {
          doc.classList.remove("visible");
          doc.classList.add("hidden");
          localStorage.setItem(`maa-state-${ASK_AI_SCRIPT_ID}`, "closed");
          doc.style.display = "none";
        } else {
          doc.classList.remove("hidden");
          doc.classList.add("visible");
          localStorage.setItem(`maa-state-${ASK_AI_SCRIPT_ID}`, "open");
          doc.style.display = "block";
        }

        updateBtnVisible();
      });

      // 监听 class 变化
      const classObserver = new MutationObserver(() => {
        updateBtnVisible();
      });

      classObserver.observe(doc, {
        attributes: true,
        attributeFilter: ["class"],
      });

      // 初始化状态
      updateBtnVisible();

      // 添加按钮
      setTimeout(() => {
        doc.appendChild(closeBtn);
      }, 500);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function injectAskAiBaseStyles() {
    if (document.getElementById("askai-chat-base-style")) return;

    var css = document.createElement("style");
    css.id = "askai-chat-base-style";
    css.textContent =
      "html." +
      ASK_AI_ACTIVE_CLASS +
      " #" +
      ASK_AI_BUTTON_ID +
      ":not([" +
      ASK_AI_CUSTOMIZED_ATTR +
      '="true"]) {' +
      " visibility: hidden !important;" +
      " opacity: 0 !important;" +
      " transition: opacity 0.15s ease !important;" +
      "}" +
      "#" +
      ASK_AI_BUTTON_ID +
      "[" +
      ASK_AI_CUSTOMIZED_ATTR +
      '="true"] {' +
      " visibility: visible !important;" +
      " opacity: 1 !important;" +
      "}" +
      "#" +
      ASK_AI_BUTTON_ID +
      "#" +
      ASK_AI_BUTTON_ID +
      " {" +
      " width: auto !important;" +
      " max-width: none !important;" +
      " height: 40px !important;" +
      " min-width: 92px !important;" +
      " min-height: 0 !important;" +
      " border-radius: 20px !important;" +
      " padding: 0 16px 0 12px !important;" +
      " display: flex !important;" +
      " align-items: center !important;" +
      " gap: 8px !important;" +
      " z-index: 90 !important;" +
      " background: #1a1a1a !important;" +
      " background-image: none !important;" +
      " background-size: 0 !important;" +
      " animation: none !important;" +
      " overflow: visible !important;" +
      " box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;" +
      "}" +
      "#" +
      ASK_AI_BUTTON_ID +
      "[" +
      ASK_AI_CUSTOMIZED_ATTR +
      '="true"] > :not(.' +
      ASK_AI_CUSTOM_CONTENT_CLASS +
      ") {" +
      " display: none !important;" +
      "}" +
      "#" +
      ASK_AI_BUTTON_ID +
      "#" +
      ASK_AI_BUTTON_ID +
      ".askai-fade-in {" +
      " width: auto !important;" +
      " max-width: none !important;" +
      " height: 40px !important;" +
      " border-radius: 20px !important;" +
      " background-image: none !important;" +
      " overflow: visible !important;" +
      "}";
    document.head.appendChild(css);
  }

  function getAskAiButton() {
    return document.getElementById(ASK_AI_BUTTON_ID);
  }

  function setAskAiHideWindowActive(isActive) {
    if (!document.documentElement) return;
    document.documentElement.classList.toggle(ASK_AI_ACTIVE_CLASS, isActive);
  }

  function stopAskAiObserver() {
    if (askAiObserver) {
      askAiObserver.disconnect();
      askAiObserver = null;
    }

    if (askAiObserverTimeout) {
      clearTimeout(askAiObserverTimeout);
      askAiObserverTimeout = null;
    }

    if (askAiHideWindowTimeout) {
      clearTimeout(askAiHideWindowTimeout);
      askAiHideWindowTimeout = null;
    }

    setAskAiHideWindowActive(false);
  }

  function startAskAiObserver() {
    if (!document.body) return;

    setAskAiHideWindowActive(true);

    if (askAiObserverTimeout) {
      clearTimeout(askAiObserverTimeout);
      askAiObserverTimeout = null;
    }

    if (askAiHideWindowTimeout) {
      clearTimeout(askAiHideWindowTimeout);
      askAiHideWindowTimeout = null;
    }

    if (!askAiObserver) {
      askAiObserver = new MutationObserver(function () {
        scheduleAskAiCustomization();
      });

      askAiObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    askAiObserverTimeout = setTimeout(function () {
      stopAskAiObserver();
    }, ASK_AI_OBSERVER_TIMEOUT_MS);

    askAiHideWindowTimeout = setTimeout(function () {
      setAskAiHideWindowActive(false);
    }, ASK_AI_HIDE_WINDOW_MS);
  }

  function loadDeferredAnalytics() {
    if (analyticsLoaded) return;
    analyticsLoaded = true;

    // Microsoft Clarity Tracking Code
    if (CLARITY_ID) {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
    }

    if (TWITTER_PIXEL_ID) {
    !(function (e, t, n, s, u, a) {
      e.twq ||
        ((s = e.twq =
          function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
          }),
        (s.version = "1.1"),
        (s.queue = []),
        (u = t.createElement(n)),
        (u.async = !0),
        (u.src = "https://static.ads-twitter.com/uwt.js"),
        (a = t.getElementsByTagName(n)[0]),
        a.parentNode.insertBefore(u, a));
    })(window, document, "script");
    twq("config", TWITTER_PIXEL_ID);
    }

    if (BING_UET_ID) {
    (function (w, d, t, r, u) {
      var f, n, i;
      w[u] = w[u] || [];
      f = function () {
        var o = {
          ti: BING_UET_ID,
          tm: "shpfy_ui",
          enableAutoSpaTracking: true,
        };
        o.q = w[u];
        w[u] = new UET(o);
        w[u].push("pageLoad");
      };
      n = d.createElement(t);
      n.src = r;
      n.async = 1;
      n.onload = n.onreadystatechange = function () {
        var s = this.readyState;
        (s && s !== "loaded" && s !== "complete") ||
          (f(), (n.onload = n.onreadystatechange = null));
      };
      i = d.getElementsByTagName(t)[0];
      i.parentNode.insertBefore(n, i);
    })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
    }
  }

  function loadAskAiChat() {
    if (!ASK_AI_EMBED_ID || askAiLoaded || document.getElementById(ASK_AI_SCRIPT_ID)) return;
    askAiLoaded = true;
    startAskAiObserver();

    var script = document.createElement("script");
    script.defer = true;
    script.type = "text/javascript";
    script.src =
      "https://myaskai.com/api/1.1/wf/embed-v2?i=" + encodeURIComponent(ASK_AI_EMBED_ID);
    script.id = ASK_AI_SCRIPT_ID;
    document.head.appendChild(script);
  }

  function applyAskAiCustomization(btn) {
    if (!btn || btn.getAttribute(ASK_AI_CUSTOMIZED_ATTR) === "true") return;

    var content = document.createElement("span");

    content.className = ASK_AI_CUSTOM_CONTENT_CLASS;

    content.style.cssText =
      "display:flex;align-items:center;gap:8px;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;";

    var icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    icon.setAttribute("width", "20");
    icon.setAttribute("height", "20");
    icon.setAttribute("viewBox", "0 0 20 20");
    icon.setAttribute("fill", "none");
    icon.setAttribute("aria-hidden", "true");

    icon.style.flexShrink = "0";

    const helpIcon = `
        <circle cx="10" cy="10" r="9" stroke="white" stroke-width="1.5"/>
        <path d="M7.5 7.5C7.5 6.12 8.62 5 10 5C11.38 5 12.5 6.12 12.5 7.5C12.5 8.88 11.38 10 10 10V11.5" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="10" cy="14.5" r="1" fill="white"/>
        `;

    const closeIcon = `
        <circle cx="10" cy="10" r="9" stroke="white" stroke-width="1.5"/>
        <path
            d="M7 7L13 13"
            stroke="white"
            stroke-width="1.8"
            stroke-linecap="round"
        />

        <path
            d="M13 7L7 13"
            stroke="white"
            stroke-width="1.8"
            stroke-linecap="round"
        />
        <circle cx="10" cy="14.5" fill="white"/>
    `;

    var label = document.createElement("span");

    label.style.cssText =
      "color:#fff;font-family:-apple-system,BlinkMacSystemFont,sans-serif;font-size:14px;font-weight:500;white-space:nowrap;";

    // =========================
    // 更新按钮文字
    // =========================

    function updateLabel() {
      var frame = document.querySelector(
        '[data-id="' + ASK_AI_SCRIPT_ID + '"]',
      );

      var isVisible = frame && frame.classList.contains("visible");

      label.textContent = isVisible ? "Close" : "Help";

      icon.innerHTML = isVisible ? closeIcon : helpIcon;

      btn.setAttribute("aria-label", isVisible ? "Close" : "Help");
    }

    updateLabel();

    content.appendChild(icon);
    content.appendChild(label);

    btn.appendChild(content);

    btn.setAttribute(ASK_AI_CUSTOMIZED_ATTR, "true");

    // =========================
    // 监听 open/close
    // =========================

    var frameObserver = new MutationObserver(function () {
      updateLabel();
    });

    function observeFrame() {
      var frame = document.querySelector(
        '[data-id="' + ASK_AI_SCRIPT_ID + '"]',
      );

      if (!frame) {
        requestAnimationFrame(observeFrame);
        return;
      }

      frameObserver.observe(frame, {
        attributes: true,
        attributeFilter: ["class"],
      });

      updateLabel();
    }

    observeFrame();

    setAskAiHideWindowActive(false);
  }

  function customizeAskAiChatNow() {
    injectAskAiBaseStyles();

    var btn = getAskAiButton();
    if (!btn) {
      startAskAiObserver();
      return;
    }

    applyAskAiCustomization(btn);
    startAskAiObserver();
  }

  function scheduleAskAiCustomization() {
    if (askAiCustomizeScheduled) return;

    askAiCustomizeScheduled = true;
    setTimeout(function () {
      askAiCustomizeScheduled = false;
      customizeAskAiChatNow();
    }, 0);
  }

  function scheduleAnalyticsLoad() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(
        function () {
          setTimeout(loadDeferredAnalytics, 500);
        },
        { timeout: 1500 },
      );
    } else {
      setTimeout(loadDeferredAnalytics, 1000);
    }
  }

  function scheduleAskAiLoad() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(
        function () {
          setTimeout(loadAskAiChat, 1500);
        },
        { timeout: 2500 },
      );
    } else {
      setTimeout(loadAskAiChat, 2000);
    }
  }

  var interactionEvents = [
    "scroll",
    "click",
    "touchstart",
    "mousemove",
    "keydown",
  ];

  function onInteraction() {
    loadDeferredAnalytics();
    loadAskAiChat();
    scheduleAskAiCustomization();
    interactionEvents.forEach(function (event) {
      window.removeEventListener(event, onInteraction, { passive: true });
    });
  }

  interactionEvents.forEach(function (event) {
    window.addEventListener(event, onInteraction, {
      passive: true,
      once: true,
    });
  });

  injectAskAiBaseStyles();

  if (document.readyState === "complete") {
    scheduleAnalyticsLoad();
    scheduleAskAiLoad();
    scheduleAskAiCustomization();
    initCloseBtn();
  } else {
    window.addEventListener("load", function () {
      scheduleAnalyticsLoad();
      scheduleAskAiLoad();
      scheduleAskAiCustomization();
      initCloseBtn();
    });
  }
})();
